import React, { useState } from "react";
import "../styles/FlipCard.css";

const FlipCard = ({
  front,
  back,
  flipOn = "click",
  className = "p-5",
  width = "200px",
  height = "200px",
}) => {
  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => {
    if (flipOn === "click") {
      setFlipped((prev) => !prev);
    }
  };

  return (
    <div
      className={`flip-card ${flipped ? "flipped" : ""} ${
        flipOn === "hover" ? "hover-flip" : ""
      } ${className}`}
      style={{
        width,
        height,
      }}
      onClick={handleFlip}
    >
      <div className="flip-inner">
        <div className="flip-front">{front}</div>
        <div className="flip-back">{back}</div>
      </div>
    </div>
  );
};

export default FlipCard;
